export const catalogHitSearchTpl = `
<article class="flex border-b border-gray-100">
  <a href="{{ url }}" class="flex px-4 py-1 sm:px-6 w-full hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
    <div class="flex w-full items-center">
        <div class="h-16 w-16">
        {{#thumbnail}}
            <img class="w-full" src="{{ thumbnail }}">
        {{/thumbnail}}
        </div>
        <div class="min-w-0 flex-1 px-4">
            <h3 class="text-base leading-tight font-semibold text-gray-900">
               {{ title }}
            </h3>
        </div>
            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
    </svg>
    </div>

  </a>
</article>
`;
